import { render, staticRenderFns } from "./Prosecco.vue?vue&type=template&id=210882fa&"
import script from "./Prosecco.vue?vue&type=script&lang=js&"
export * from "./Prosecco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports